import React, { Fragment, useEffect, useState } from "react";

import SideNav from "../../Components/SideNav";
import FormularioAgregar from "../../Components/FormularioAgregar";
import FormularioEditar from "../../Components/FormularioEditar";
import View from "./View";

import { useAuth } from "../../Context/Context";

import BanersHelper from "../../Helpers/Baners";

const Etiquetas = () => {
  const { editar } = useAuth();

  const [etiqueta, setEtiqueta] = useState({
    tipo: 1,
    titulo: "",
  });

  useEffect(() => {
    setEtiqueta({ ...editar, ...etiqueta });
  }, [editar]);

  const leerDato = (e) => {
    setEtiqueta({
      ...etiqueta,
      [e.target.name]: e.target.value,
    });
  };

  const agregarBaner = (e) => {
    e.preventDefault();
    console.log({ etiqueta });
    BanersHelper.agregarBaner(etiqueta);
  };

  const editarBaner = (e) => {
    e.preventDefault();
    BanersHelper.editarBaner(etiqueta, editar._id);
  };

  return (
    <Fragment>
      <SideNav />
      <div className="row">
        <FormularioAgregar>
          <p className="titulo_1_admin">Agregar baner</p>

          <form onSubmit={agregarBaner}>
            <div className="input-field">
              <input
                onChange={leerDato}
                id="titulo"
                name="titulo"
                type="text"
                className="validate"
              />
              <label for="titulo">Titulo</label>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Agregar baner</button>
            </div>
          </form>
        </FormularioAgregar>
        <FormularioEditar>
          <p className="titulo_1_admin">Editar baner</p>
          <form onSubmit={editarBaner}>
            <div className="input-field">
              <input
                onChange={leerDato}
                defaultValue={editar.titulo}
                id="titulo"
                name="titulo"
                type="text"
                className="validate"
              />
              <label className="active" for="titulo">
                Titulo
              </label>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Actualizar baner</button>
            </div>
          </form>
        </FormularioEditar>
        <View />
      </div>
    </Fragment>
  );
};

export default Etiquetas;
